export default __webpack_public_path__ + "static/media/vocalnet.5867514d.png";